function DDUMainLaps({value}) {
    return (
        <div className="flex flex-col items-center justify-center w-[33%]">
            <h2 className="flex items-center font-bold text-[25px] mt-[-5px]">{value["completed-laps"]} {Math.floor(value["raw-laps"]) !== 0 && <span className="text-[#4b4a4a] text-[20px]">/~{value["raw-laps"].toFixed(1)}</span>}</h2>
            <p className="uppercase text-[#4b4a4a] font-bold text-[11px] mt-[-5px]">Lap</p>
        </div>
    );
}

export default DDUMainLaps;